import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";
import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import { FormBuilderSwitch } from "../components/Switch";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";

const RadioButtonGroup = () => {
  const { state, dispatch } = useContext(FormBuilderContext);

  const handleToggleRadioButton = (event) => {
    dispatch({
      type: ACTIONS.TOGGLE_RADIO,
      payload: event.target.checked,
    });
  };

  const handleColorChange = (actionType) => (color) => {
    dispatch({ type: actionType, payload: color });
  };
  const handleRadioAlignmentChange = (event) => {
    dispatch({
      type: ACTIONS.RADIO_ALIGNMENT,
      payload: event.target.value,
    });
  };
  const handleRadioFontWeightChange = (event) => {
    dispatch({
        type: ACTIONS.RADIO_LABEL_FONT_WEIGHT_INPUT,
        payload: event.target.value,
    });
};

const handleRadioLabelFontFamilyChange = (event) => {
    dispatch({
        type: ACTIONS.RADIO_LABEL_FONT_FAMILY_CHANGE,
        payload: event.target.value,
    });
};

  return (
    <div>
      <p>Add radio button? </p>
      <FormBuilderSwitch
        checked={state.addRadioButton}
        onChange={handleToggleRadioButton}
      />
      {state.addRadioButton && (
        <>
          <div>
            <h2 className="section-subheader">General styles</h2>
            <div className="input-group-wrapper">
              <InputSection
                id="radioInputSize"
                title="Size"
                value={state.radioInputSize}
                actionTypeIncrement={ACTIONS.RADIO_INPUT_SIZE_INCREMENT}
                actionTypeDecrement={ACTIONS.RADIO_INPUT_SIZE_DECREMENT}
                actionTypeInput={ACTIONS.RADIO_INPUT_SIZE_INPUT}
                dispatch={dispatch}
              />

              <InputSection
                id="radioBorderWidth"
                title="Border Width"
                value={state.radioBorderWidth}
                actionTypeIncrement={ACTIONS.RADIO_BORDER_WIDTH_INCREMENT}
                actionTypeDecrement={ACTIONS.RADIO_BORDER_WIDTH_DECREMENT}
                actionTypeInput={ACTIONS.RADIO_BORDER_WIDTH_INPUT}
                dispatch={dispatch}
              />

              <InputSection
                id="radioBorderRadius"
                title="Border Radius"
                value={state.radioBorderRadius}
                actionTypeIncrement={ACTIONS.RADIO_BORDER_RADIUS_INCREMENT}
                actionTypeDecrement={ACTIONS.RADIO_BORDER_RADIUS_DECREMENT}
                actionTypeInput={ACTIONS.RADIO_BORDER_RADIUS_INPUT}
                dispatch={dispatch}
              />
            </div>
          </div>
          <div>
            <h2 className="section-subheader">Unchecked styles</h2>
            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Border Color</p>
                <ColorPickerInput
                  color={state.radioUncheckedBorderColor}
                  onChange={handleColorChange(
                    ACTIONS.RADIO_UNCHECKED_BORDER_COLOR_INPUT
                  )}
                />
              </div>
              <div className="form-builder-section-div">
                <p>Background Color</p>
                <ColorPickerInput
                  color={state.radioUncheckedBackgroundColor}
                  onChange={handleColorChange(
                    ACTIONS.RADIO_UNCHECKED_BACKGROUND_COLOR_INPUT
                  )}
                />
              </div>
            </div>
          </div>
          <div>
            <h2 className="section-subheader">Checked styles</h2>
            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Background Color</p>
                <ColorPickerInput
                  color={state.radioCheckedBackgroundColor}
                  onChange={handleColorChange(
                    ACTIONS.RADIO_CHECKED_BACKGROUND_COLOR_INPUT
                  )}
                />
              </div>

              <div className="form-builder-section-div">
                <p>Border Color</p>
                <ColorPickerInput
                  color={state.radioCheckedBorderColor}
                  onChange={handleColorChange(
                    ACTIONS.RADIO_CHECKED_BORDER_COLOR_INPUT
                  )}
                />
              </div>
            </div>
            <h2 className="section-subheader">radio buttons alignment</h2>

            <div className="input-group-wrapper">
              <div className="form-builder-section-div">
                <p>Choose layout</p>
                <CustomSelect
                  labelId="radio-alignment"
                  id="radio-alignment"
                  selectValue={state.radioAlignment}
                  selectLabel="Radio Alignment"
                  selectOnChange={handleRadioAlignmentChange}
                  menuItems={[
                    { value: "left", label: "horizontal" },
                    { value: "none", label: "stacked" },
                  ]}
                />
              </div>
            </div>
          </div>

          <h2 className="section-subheader">Label Font styles</h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Font Family</p>
                            <FontFamilySelect
                                selectedFontFamily={state.radioLabelFontFamily}
                                onFontFamilyChange={handleRadioLabelFontFamilyChange}
                            />
                        </div>

                        <InputSection
                            id="radioFontSize"
                            title="Font size"
                            value={state.radioLabelFontSize}
                            actionTypeIncrement={ACTIONS.RADIO_LABEL_FONT_SIZE_INCREMENT}
                            actionTypeDecrement={ACTIONS.RADIO_LABEL_FONT_SIZE_DECREMENT}
                            actionTypeInput={ACTIONS.RADIO_LABEL_FONT_SIZE_INPUT}
                            dispatch={dispatch}
                        />
                        <div>
                            <p>Font Weight</p>
                            <CustomSelect
                                labelId="font-weight-radio"
                                id="font-weight-radio"
                                selectValue={state.radioLabelFontWeight}
                                selectLabel="Font Weight"
                                selectOnChange={handleRadioFontWeightChange}
                                menuItems={[
                                    { value: 100, label: "100" },
                                    { value: 200, label: "200" },
                                    { value: 300, label: "300" },
                                    { value: 400, label: "400" },
                                    { value: 500, label: "500" },
                                    { value: 600, label: "600" },
                                    { value: 700, label: "700" },
                                    { value: 800, label: "800" },
                                    { value: 900, label: "900" },
                                ]}
                            />
                        </div>
                    </div>

                    <h2 className="section-subheader">Label Color styles </h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Text Color</p>
                            <ColorPickerInput
                                color={state.inputColor}
                                onChange={handleColorChange(ACTIONS.RADIO_LABEL_COLOR_INPUT)}
                            />
                        </div>

                    </div>
        </>
      )}
    </div>
  );
};

export default RadioButtonGroup;
